module.exports = __webpack_public_path__ + "static/aichef-beee0e31358ec2cf58fca924c25e4247.png";